import React from "react"

import { LocalizedLink as Link } from "gatsby-theme-i18n"
import { useIntl } from "react-intl"

const PoliciesNavigation = ({ location }) => {
  const page = location.pathname.split("/").pop()
  return (
    <ul className="nav nav-pills mb-2">
      <NavLink page={page} to="policies" title="Welcome" />
      <NavLink
        page={page}
        to="policies_terms"
        title="Terms and Conditions"
      />
      <NavLink page={page} to="policies_privacy" title="Privacy Policy" />
      <NavLink page={page} to="policies_aml" title="AML Policy" />
      <NavLink page={page} to="policies_cookies" title="Cookie Policy" />
      <NavLink page={page} to="policies_us" title="US Policy" />
    </ul>
  )
}

const NavLink = ({ page, to, title }) => {
  const intl = useIntl()
  return (
    <Link
      to={"/" + to}
      className={"nav-link " + (page == to ? "active" : "") + " mr-1 mb-1"}
    >
      {intl.formatMessage({ id: title })}
    </Link>
  )
}

export default PoliciesNavigation
